import { jsx as _jsx } from "react/jsx-runtime";
import Typography from "../../Typography";
const BannerLabel = ({ className, children, color = "secondary", variant = "text-sm" }) => {
    return (_jsx(Typography, { color: color, variant: variant, className: className, children: children }));
};
export default BannerLabel;
